import MaterialSkeleton, { SkeletonProps } from '@mui/material/Skeleton';

export function Skeleton(props: SkeletonProps) {
    return <MaterialSkeleton data-testid={'skeleton-container'} {...props} />;
}

export default Skeleton;
